import Request, { SimpleResponse } from './Request';
import { IUser } from './User';

export interface IForecast {
    id: number;
    groupId: number;
    groupName: string;
    groupCode: string;
    groupParentId: number;

    status: IStatus;

    channels: IChannel[];
    children: IForecast[];
}

export interface IChannel {
    channelId: number;
    channelName: string;
    channelOrder: number;

    id: number;
    tradeSalesForecastWeek1: number;
    tradeSalesForecastWeek2: number;
    tradeSalesForecastWeek3: number;
    tradeSalesForecastWeek4: number;
}

export interface IStatus {
    id: number;
    name: string;
    slug: string;
    order: string;
}

export interface IMessage {
    id: number;
    tradeSaleId: number;
    message: string;
    creationDate: Date;
    user: IUser;
}

class Forecast {
    static GetAllStatus = (): IStatus[] => { return Request.DoGet('forecast/status') as unknown as IStatus[]; };
    static SetStatus = (id: Number, data: IStatus): SimpleResponse => { return Request.DoPut('forecast/status/' + id, data) as unknown as SimpleResponse; };
    static GetMessages = (tradesaleId: Number): IMessage[] => { return Request.DoGet('forecast/messages/' + tradesaleId) as unknown as IMessage[]; };
    static CreateMessage = (data: IMessage): SimpleResponse => { return Request.DoPost('forecast/messages', data) as unknown as SimpleResponse; };
    static GetAll = (year: Number, month: Number): IForecast[] => { return Request.DoGet('forecast/all/' + year + '/' + month) as unknown as IForecast[]; };
    static Get = (group: Number, year: Number, month: Number): IForecast => { return Request.DoGet('forecast/' + group + '/' + year + '/' + month) as unknown as IForecast; };
    static Update = (id: Number, data: IForecast): SimpleResponse => { return Request.DoPut('forecast/' + id, data) as unknown as SimpleResponse; };
    static Create = (year: Number, month: Number, data: IForecast): SimpleResponse => { return Request.DoPost('forecast/' + year + '/' + month, data) as unknown as SimpleResponse; };
}

export default Forecast;